import Layout from "@/layout/index.vue";

export default [
  // 赠转短
  {
    path: "/zzd",
    name: "zzd",
    component: Layout,
    redirect: "/buryingpoint",
    meta: {
      title: "赠转短",
    },
    children: [
      {
        path: "/buryingpoint",
        name: "buryingpoint",
        component: () => import("@/views/page/zzd/BuryingPoint.vue"),
        meta: {
          title: "埋点报表",
        },
      },
      {
        path: "/zzd_report",
        name: "zzd_report",
        component: () => import("@/views/page/zzd/ZzdReport.vue"),
        meta: {
          title: "业务报表",
        },
      },
    ],
  },
  // 影君艺术
  {
    path: "/yjys",
    name: "yjys",
    component: Layout,
    redirect: "/painting_report",
    meta: {
      title: "影君艺术",
    },
    children: [
      {
        path: "/painting_report",
        name: "paintingReport",
        component: () => import("@/views/page/mttf/PaintingReport.vue"),
        meta: {
          title: "书画报表",
        },
      },
    ],
  },
  // 系统配置
  {
    path: "/xtpz",
    name: "xtpz",
    component: Layout,
    redirect: "/burieddictionary",
    meta: {
      title: "系统配置",
    },
    children: [
      {
        path: "/burieddictionary",
        name: "burieddictionary",
        component: () => import("@/views/page/xtpz/BuriedDictionary.vue"),
        meta: {
          title: "埋点字典",
        },
      },
      {
        path: "/channel",
        name: "channel",
        component: () => import("@/views/page/xtpz/ChannelTest.vue"),
        meta: {
          title: "渠道测试",
        },
      },
      {
        path: "/sceneconfiguration",
        name: "sceneconfiguration",
        component: () => import("@/views/page/xtpz/SceneConfiguration.vue"),
        meta: {
          title: "场景配置",
        },
      },
    ],
  },
]